var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$auth.hasPermissions('bee.mappings'))?_c('v-btn',{attrs:{"color":_vm.btnColor},on:{"click":_vm.btnClick}},[_c('v-icon',{staticClass:"mr-1"},[_vm._v("mdi-pencil")]),_vm._v(" "+_vm._s(_vm.btnText)+" ")],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }